let _browserType = null;
let _version = null;

/**
 * Detects and caches the browser type.
 * @returns {string} The browser type.
 */
export function browserType() {
    if (_browserType !== null) return _browserType;

    const agent = window.navigator.userAgent.toLowerCase();

    if (agent.includes('edg')) {
        _browserType = 'edge';
    } else if (agent.includes('opr') && !!window.opr) {
        _browserType = 'opera';
    } else if (window.navigator.brave) {
        _browserType = 'brave';
    } else if ((agent.includes('chrome') && !!window.chrome) || agent.includes('crios')) {
        _browserType = 'chrome';
    } else if (agent.includes('trident')) {
        _browserType = 'ie';
    } else if (agent.includes('firefox')) {
        _browserType = 'firefox';
    } else if (agent.includes('safari')) {
        _browserType = 'safari';
    } else {
        _browserType = 'other';
    }

    return _browserType;
}

/**
 * Detects and caches version/platform information from the user agent.
 * @returns {Object} An object containing version/platform flags.
 */
export function versions() {
    if (_version !== null) return _version;

    const ua = navigator.userAgent;

    _version = {
        presto: ua.includes('Presto'),
        trident: ua.includes('Trident'),
        webKit: ua.includes('AppleWebKit'),
        gecko: ua.includes('Gecko') && !ua.includes('KHTML'),
        android: ua.includes('Android') || ua.includes('Linux'),
        ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua),
        iPhone: ua.includes('iPhone') || ua.includes('Mac'),
        iPad: ua.includes('iPad'),
        webApp: !ua.includes('Safari'),
        mobile: /AppleWebKit.*Mobile.*/.test(ua) || /AppleWebKit/.test(ua),
    };

    return _version;
}
